import * as React from 'react';

export default class TreeViewItem extends React.Component {
  render() {
    return (
        <li>
            {this.props.children}
        </li>
    );
  }
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-react-wrapper/src/treeview/treeviewitem.tsx